import React, { useCallback, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import styles from "./PdfViewer.module.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useRef, useEffect, useLayoutEffect } from "react";
import { connect } from "react-redux";
import {
  Box,
  ButtonGroup,
  HStack,
  IconButton,
  Input,
  flexbox,
  Tooltip,
  Spinner,
  Text
} from "@chakra-ui/react";
import { Resize1, Resize2, TwoPage, ZoomIn, ZoomOut } from "./icons";
// import Loading from "./Loading";


if (pdfjs.version === "2.16.105" && window.location.hostname !== "localhost") {
  var url = "/static/js/pdf.worker.min.js";
} else {
  url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
}
pdfjs.GlobalWorkerOptions.workerSrc = url;

const pdfHighlightId = "pdf_highlighted_text";

function highlightPattern(text, pattern) {
  return text.replace(
    pattern,
    (value) => `<mark id="${pdfHighlightId}">${value}</mark>`
  );
}
function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }
function toWordSetPdf(str) {
  return (str || "").toLowerCase().match(/[a-z]{2,}/g) || [];
}
function buildPdfTextIndex(container) {
  const spans = Array.from(container.querySelectorAll(".react-pdf__Page__textContent span"));
  let fullText = "";
  const map = [];
  spans.forEach((span) => {
    const text = span.textContent || "";
    const start = fullText.length;
    fullText += text + " ";
    map.push({ el: span, start, end: fullText.length - 1 });
  });
  return { fullText, map };
}
function findSpanAt(map, charIndex) {
  return map.find((m) => charIndex >= m.start && charIndex <= m.end);
}
const jumpHighlightClass = "pdf_editor_jump_highlight";
// function getTextItemWithNeighbors(textItems, itemIndex, span = 1) {
//   console.log(textItems, itemIndex);
//   window.t = textItems;
//   return textItems.slice(
//     Math.max(0, itemIndex - span),
//     itemIndex + 1 + span
//   )
//     .filter(Boolean)
//     .map(item => item.str)
//     .join('');
// }

// function getIndexRange(string, substring) {
//   const indexStart = string.indexOf(substring);
//   const indexEnd = indexStart + substring.length;

//   return [indexStart, indexEnd];
// }

const PdfViewer = (props) => {
  const [numPages, setNumPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const isMouseInsideRef = useRef(false);
  // const [secondpage, setsecondpage] = useState(2);
  const ref = useRef(null);
  const pageref = useRef(null);
  const scale = props.scale !== undefined ? props.scale : 0.2;
  const setScale = (newScale) => {
    if (props.control) {
      props.control(prev => ({
        ...prev,
        scale: typeof newScale === 'function' ? newScale(scale) : newScale
      }));
    }
  };
  const [twoPageView, setTwoPageView] = useState(false);

  const textRenderer = useCallback(
    (textItem) => highlightPattern(textItem.str, props.pdfsearch),
    [props.pdfsearch]
  );

  // const [textItems, setTextItems] = useState();

  // const onPageLoadSuccess = useCallback(async page => {
  //   const textContent = await page.getTextContent();
  //   setTextItems(textContent.items);
  // }, []);

  // console.log(textItems);


  // const textRenderer = useCallback((textItem, textItems) => {
  //   if (!textItem) {
  //     return;
  //   }
  //   const { itemIndex } = textItem;
  //   const matchInTextItem = textItem.str.match(props.pdfsearch);
  //   if (matchInTextItem) {
  //     // Found full match within current item, no need for black magic
  //     return highlightPattern(textItem.str, props.pdfsearch);
  //   }
  //   // Full match within current item not found, let's check if we can find it
  //   // spanned across multiple lines

  //   // Get text item with neighbors
  //   const textItemWithNeighbors = getTextItemWithNeighbors(textItem, itemIndex);
  //   console.log("BV");
  //   // const matchInTextItemWithNeighbors = textItemWithNeighbors.match(props.pdfsearch);

  //   // // if (!matchInTextItemWithNeighbors) {
  //   // //   // No match
  //   // //   return textItem.str;
  //   // // }

  //   // Now we need to figure out if the match we found was at least partially
  //   // in the line we're currently rendering
  //   const [matchIndexStart, matchIndexEnd] = getIndexRange(textItemWithNeighbors, props.pdfsearch);
  //   const [textItemIndexStart, textItemIndexEnd] = getIndexRange(textItemWithNeighbors, textItem.str);

  //   if (
  //     // Match entirely in the previous line
  //     matchIndexEnd < textItemIndexStart ||
  //     // Match entirely in the next line
  //     matchIndexStart > textItemIndexEnd
  //   ) {
  //     return textItem.str;
  //   }

  //   // Match found was partially in the line we're currently rendering. Now
  //   // we need to figure out what does "partially" exactly mean

  //   // Find partial match in a line
  //   const indexOfCurrentTextItemInMergedLines = textItemWithNeighbors.indexOf(textItem.str);

  //   const matchIndexStartInTextItem = Math.max(0, matchIndexStart - indexOfCurrentTextItemInMergedLines);
  //   const matchIndexEndInTextItem = matchIndexEnd - indexOfCurrentTextItemInMergedLines;

  //   const partialStringToHighlight = textItem.str.slice(matchIndexStartInTextItem, matchIndexEndInTextItem);
  //   console.log(textItem.str);

  //   return highlightPattern(textItem.str, partialStringToHighlight);
  // }, [props.pdfsearch]);

  // let file;
  // if (props.data) {
  //   file = props.data;
  // } else {
  //   file = "Loading.....";
  // }
  // console.log(props.data)
  useEffect(() => {
    let isScrollingTimeout = null;
    const isScrolling = () => {
      clearTimeout(isScrollingTimeout);
      isScrollingTimeout = setTimeout(() => {
        // const totalpage = numPages;
        let pageht;
        if (!props.pdfContainer?.current) return;
        const scrollPos = props.pdfContainer.current.scrollTop;
        if (pageref.current) {
          pageht = pageref.current.clientHeight;
        }
        if (twoPageView) {
          let currentPage = Math.floor(scrollPos / pageht) + 1;
          let twopage = currentPage * 2 - 1;
          // if (currentPage <= totalpage / 2) {
          //   setsecondpage(twopage + 1);
          // } else {
          //   setsecondpage("-");
          // }
          setCurrentPage(twopage);
        } else {
          let currentPage = Math.floor(scrollPos / pageht) + 1;
          setCurrentPage(currentPage);
        }
      }, 100);
    };

    if (ref.current) {
      ref.current.addEventListener("wheel", isScrolling);
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener("wheel", isScrolling);
      }
      clearTimeout(isScrollingTimeout);
    };
  }, [twoPageView, props.pdfContainer]);

  const hasScrolledToHighlight = useRef(false);

  useEffect(() => {
    hasScrolledToHighlight.current = false;
  }, [props.pdfsearch]);

  function scrollIntoView() {
    var highlightElement = document.getElementById(pdfHighlightId);
    if (highlightElement) {
      if (highlightElement.innerText !== "") {
        document.getElementById(pdfHighlightId).scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center",
        });
        hasScrolledToHighlight.current = true;
      }
    }
  }

  const navtopage = () => {
    if (currentPage > 0 && currentPage <= numPages && props.pdfContainer?.current && pageref.current) {
      let pageht = pageref.current.clientHeight;
      props.pdfContainer.current.scrollTop = pageht * (currentPage - 1);
      document.activeElement.blur();
    }
  };

  // function selectText() {
  //   props.pdfSearch("");
  //   props.latexSearch(window.getSelection().toString());
  // }
  // function selectText() {
  //   props.pdfSearch("");
  //   const selection = window.getSelection();
  //   const word = selection.toString().trim();
  //   if (!word) return;

  //   let context = word;
  //   try {
  //     const node = selection.anchorNode;
  //     const wordEl = node.nodeType === 3 ? node.parentElement : node;


  //     const parent = wordEl.parentElement;
  //     if (parent && parent.children && parent.children.length > 1) {
  //       const siblings = Array.from(parent.children);
  //       const idx = siblings.indexOf(wordEl);
  //       const start = Math.max(0, idx - 6);
  //       const end = Math.min(siblings.length, idx + 7);
  //       context = siblings.slice(start, end).map(el => el.textContent).join(" ");
  //     } else if (parent) {

  //       context = parent.textContent;
  //     }
  //   } catch (e) {
  //     context = word;
  //   }

  //   props.latexSearch({ word, context: context.trim() });
  // }



  function selectText() {
    props.pdfSearch("");
    const selection = window.getSelection();
    const selectedText = selection.toString().trim();
    if (!selectedText) return;


    const words = selectedText.split(/\s+/).filter(Boolean);
    const anchorWord = words[0];

    let context = selectedText;
    try {
      const node = selection.anchorNode;
      const wordEl = node.nodeType === 3 ? node.parentElement : node;
      const parent = wordEl.parentElement;

      if (parent && parent.children && parent.children.length > 1) {
        console.log("checking for the sample selected text:", parent);
        const siblings = Array.from(parent.children).filter(el => {
          const tag = el.tagName.toLowerCase();
          if (tag === "svg" || tag.startsWith("mjx") || el.classList.contains("MathJax")) return false;
          return true;
        });
        const idx = siblings.indexOf(wordEl);
        const start = Math.max(0, idx - 8);
        const end = Math.min(siblings.length, idx + words.length + 8);
        context = siblings.slice(start, end).map(el => el.textContent).join(" ");
      } else if (parent) {
        context = parent.textContent;
        console.log("checking for the sample selected text: else if block", parent);
      }
    } catch (e) {
      context = selectedText;
      console.log("checking for the sample selected text: catch block", selectedText);
    }
    console.log("checking for the sample selected text: selectedText", selectedText, "anchorWord", anchorWord, "context", context);
    props.latexSearch({
      word: anchorWord,
      fullText: selectedText,
      context: context.trim(),
    });
  }

  const twoPageToggle = () => {
    setTwoPageView(!twoPageView);
  };

  function onLoadSuccess({ numPages }) {
    setNumPages(numPages);
    if (props.pdfContainer && props.prevScroll > 0) {
      let attempts = 0;
      const tryScroll = () => {
        if (props.pdfContainer?.current) {
          const container = props.pdfContainer.current;
          container.scrollTo(0, props.prevScroll);

          const currentScroll = container.scrollTop;
          const maxScroll = container.scrollHeight - container.clientHeight;


          const reachedTarget = Math.abs(currentScroll - props.prevScroll) < 5;
          const reachedEnd = container.scrollHeight > container.clientHeight + 100 && Math.abs(currentScroll - maxScroll) < 5;

          if (!reachedTarget && !reachedEnd && attempts < 25) {
            attempts++;
            // Rapid attempts early on, then slow down
            const delay = attempts < 10 ? 100 : 400;
            setTimeout(tryScroll, delay);
          } else {
            // FINAL STEP: Release the guard so App.js starts listening to scroll again
            if (props.setPdfStatus) {
              props.setPdfStatus({ loading: false, error: null });
            }
          }
        } else {
          // No container, release anyway to prevent stuck state
          if (props.setPdfStatus) props.setPdfStatus({ loading: false, error: null });
        }
      };
      // Start immediately and check frequently
      setTimeout(tryScroll, 50);
      setTimeout(tryScroll, 200);
      setTimeout(tryScroll, 500);
    } else {
      // No scroll to restore, release immediately
      if (props.setPdfStatus) props.setPdfStatus({ loading: false, error: null });
    }
  }

  function onLoadError(error) {
    console.error("PDF Load Error:", error);
    if (props.setPdfStatus) {
      props.setPdfStatus({ loading: false, error: "Error rendering PDF" });
    }
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.altKey) && e.key === "-") {

        setScale(prev => {
          const next = prev - 0.1;
          return next <= 0 ? 0 : next;//zero check
        })
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.altKey) && e.key === "=") {

        setScale(prev => prev + 0.1);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);


  const scaleRef = useRef(scale);
  scaleRef.current = scale;

  const zoomAnchorRef = useRef(null);

  useEffect(() => {
    const container = props.pdfContainer?.current;
    if (!container) return;

    const ZOOM_SENSITIVITY = 0.0035;

    const handleWheelZoom = (e) => {
      if (!e.ctrlKey) return;
      e.preventDefault();

      const rect = container.getBoundingClientRect();
      zoomAnchorRef.current = {
        mouseX: e.clientX - rect.left,
        mouseY: e.clientY - rect.top,
        scrollLeft: container.scrollLeft,
        scrollTop: container.scrollTop,
        scrollWidth: container.scrollWidth,
        scrollHeight: container.scrollHeight,
      };

      // Pass a plain number, not a function — setScale's own functional-
      // update path (`newScale(scale)`) reads a stale closured `scale`
      // too, for the same reason described above.
      const next = scaleRef.current - e.deltaY * ZOOM_SENSITIVITY;
      setScale(next <= 0 ? 0 : next); // zero check, matches the -/+ button behavior
    };

    container.addEventListener("wheel", handleWheelZoom, { passive: false });
    return () => container.removeEventListener("wheel", handleWheelZoom);
  }, [props.pdfContainer]);

  useLayoutEffect(() => {
    const container = props.pdfContainer?.current;
    const anchor = zoomAnchorRef.current;
    if (!container || !anchor) return;
    zoomAnchorRef.current = null;

    const { mouseX, mouseY, scrollLeft, scrollTop, scrollWidth, scrollHeight } = anchor;
    const ratioX = scrollWidth > 0 ? container.scrollWidth / scrollWidth : 1;
    const ratioY = scrollHeight > 0 ? container.scrollHeight / scrollHeight : 1;

    container.scrollLeft = (scrollLeft + mouseX) * ratioX - mouseX;
    container.scrollTop = (scrollTop + mouseY) * ratioY - mouseY;
  }, [scale, props.pdfContainer]);

  useEffect(() => {
    if (!props.pdfsearch) return;
    const timer = setTimeout(() => {
      const highlightElement = document.getElementById(pdfHighlightId);
      if (highlightElement && highlightElement.innerText !== "") {
        highlightElement.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center",
        });
      }
    }, 600);
    return () => clearTimeout(timer);
  }, [props.pdfsearch]);

  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     if (!(e.ctrlKey || e.metaKey)) return;
  //     const isZoomIn = e.key === "+" || e.key === "=" || e.code === "NumpadAdd";
  //     const isZoomOut = e.key === "-" || e.key === "_" || e.code === "NumpadSubtract";
  //     if (!isZoomIn && !isZoomOut) return;

  //     e.preventDefault();
  //     if (isZoomIn) {
  //       setScale(scaleRef.current + 0.1);
  //     } else {
  //       const next = scaleRef.current - 0.1;
  //       setScale(next <= 0 ? 0 : next);
  //     }
  //   };
  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => document.removeEventListener("keydown", handleKeyDown);
  // }, []);
  useEffect(() => {
    const handleKeyDown = (e) => {
      // 1. Verify the PDF container exists and the cursor is physically hovering inside it
      if (!isMouseInsideRef.current) return;
 
      if (!(e.ctrlKey || e.metaKey)) return;
      const container = props.pdfContainer?.current;
      if (!container || !container.matches(':hover')) return;

      // 2. Proceed with Zoom modifier verification
      if (!(e.ctrlKey || e.metaKey)) return;
      const isZoomIn = e.key === "+" || e.key === "=" || e.code === "NumpadAdd";
      const isZoomOut = e.key === "-" || e.key === "_" || e.code === "NumpadSubtract";
      if (!isZoomIn && !isZoomOut) return;

      e.preventDefault();
      if (isZoomIn) {
        setScale(scaleRef.current + 0.1);
      } else {
        const next = scaleRef.current - 0.1;
        setScale(next <= 0 ? 0 : next);
      }
    };

    // 'passive: false' ensures e.preventDefault() can block native browser zoom actions reliably
    document.addEventListener("keydown", handleKeyDown, { passive: false });
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [props.pdfContainer]); // Added dependency to safely track ref transitions



  useEffect(() => {
    const payload = props.editorJump;
    if (!payload || !payload.word || !props.pdfContainer?.current) return;

    const timer = setTimeout(() => {
      const container = props.pdfContainer.current;
      const { fullText, map } = buildPdfTextIndex(container);
      if (!fullText.trim()) return;


      const scrollable = container.scrollHeight - container.clientHeight;
      const scrollFraction = scrollable > 0 ? container.scrollTop / scrollable : 0;
      const liveCharIndex = Math.round(fullText.length * scrollFraction);

      const pickNearest = (candidates) => {
        // candidates: [{ idx, len }]
        let best = candidates[0];
        let bestDist = Math.abs(best.idx - liveCharIndex);
        for (let i = 1; i < candidates.length; i++) {
          const dist = Math.abs(candidates[i].idx - liveCharIndex);
          if (dist < bestDist) { best = candidates[i]; bestDist = dist; }
        }
        return best;
      };

      let matchIdx = -1;
      let matchLen = payload.word.length;

      if (payload.fullText && payload.fullText.split(/\s+/).length > 1) {
        const flexPattern = payload.fullText.split(/\s+/).map(escapeRe).join("\\s+");
        const phraseRe = new RegExp(flexPattern, "gi");
        const phraseMatches = [];
        let pm;
        while ((pm = phraseRe.exec(fullText)) !== null) {
          phraseMatches.push({ idx: pm.index, len: pm[0].length });
          if (pm.index === phraseRe.lastIndex) phraseRe.lastIndex++;
        }
        if (phraseMatches.length) {
          const best = pickNearest(phraseMatches);
          matchIdx = best.idx;
          matchLen = best.len;
        }
      }

      if (matchIdx === -1) {
        const wordRe = new RegExp(`\\b${escapeRe(payload.word)}\\b`, "gi");
        const occurrences = [];
        let m;
        while ((m = wordRe.exec(fullText)) !== null) occurrences.push(m.index);
        if (occurrences.length === 0) return;

        if (occurrences.length === 1) {
          matchIdx = occurrences[0];
        } else {
          const contextSet = new Set(toWordSetPdf(payload.context));
          const WINDOW = 200;
          let bestScore = -Infinity;
          occurrences.forEach((idx) => {
            const winStart = Math.max(0, idx - WINDOW);
            const winEnd = Math.min(fullText.length, idx + payload.word.length + WINDOW);
            const windowWords = toWordSetPdf(fullText.slice(winStart, winEnd));
            let contextScore = 0;
            windowWords.forEach((w) => { if (w !== payload.word.toLowerCase() && contextSet.has(w)) contextScore++; });
            const distance = Math.abs(idx - liveCharIndex);
            const proximityScore = 1 / (1 + distance / 500);
            const score = contextScore + proximityScore;
            if (score > bestScore) { bestScore = score; matchIdx = idx; }
          });
        }
      }

      if (matchIdx === -1) return;
      const spanInfo = findSpanAt(map, matchIdx);
      if (!spanInfo) return;

      container.querySelectorAll("." + jumpHighlightClass).forEach((el) => el.classList.remove(jumpHighlightClass));
      spanInfo.el.classList.add(jumpHighlightClass);
      spanInfo.el.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
    }, 300);

    return () => clearTimeout(timer);
  }, [props.editorJump, props.pdfContainer]);


  return (
    <div className={styles.document_outer}>
      <div className={styles.header}>
        <HStack
          backgroundColor="black"
          justifyContent="space-between"
          h="48px"
          width="auto"
          zIndex={10}
        >
          <ButtonGroup spacing="1" alignItems={"center"}>
            <Box display={"flex"} alignItems={"center"} ml={2}>

              <Input
                aria-label="enter page"
                style={{
                  display: flexbox,
                  textAlign: "center",
                  height: "38px",
                  width: "38px",
                  backgroundColor: "var(--secondary-main)",
                  color: "white",
                  border: "none",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "3px",
                }}
                value={twoPageView ? `${currentPage}` : currentPage}
                onChange={(e) => {
                  setCurrentPage(e.target.value);
                  setTwoPageView(false);
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    navtopage();
                  }
                }}
              ></Input>
              <Box
                style={{
                  height: "48px",
                  width: "48px",
                  color: "white",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                }}
              >
                &nbsp; / {numPages}
              </Box>
            </Box>

            <hr style={{ height: "30px", width: "2px", background: "var(--border)", opacity: "50%", marginTop: "auto", marginBottom: "auto" }}></hr>

            <Tooltip label="Two page view">
              <IconButton
                onClick={() => twoPageToggle()}
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Text to Italic"
                icon={<TwoPage />}
                bg={twoPageView ? "var(--secondary-main)" : "var(--primary-main)"}
                _hover={{ bg: "var(--primary-main)" }}
              />
            </Tooltip>
            <hr style={{ height: "30px", width: "2px", background: "var(--border)", opacity: "50%", marginTop: "auto", marginBottom: "auto" }}></hr>
            <HStack spacing={2} align="center">

              {/* Zoom Out */}
              <Tooltip label="Zoom Out">
                <IconButton
                  id="zoomout"
                  onClick={() => {
                    if (scale > 0.05) setScale(scale - 0.1);
                  }}
                  color="white"
                  size="md"
                  bg="black"
                  aria-label="Zoom-Out"
                  icon={<ZoomOut />}
                  _hover={{ bg: "var(--primary-main)" }}
                />
              </Tooltip>

              {/* Zoom Percentage */}
              <Box
                minW="50px"
                textAlign="center"
                fontWeight="medium"
                color="white"
                // border="1px solid #f47c0d"
                borderRadius="md"
                px={2}
                py={1}
                bg="var(--secondary-main)"
              >
                {Math.round(scale / 0.2 * 100)}%
              </Box>

              {/* Zoom In */}
              <Tooltip label="Zoom In">
                <IconButton
                  id="zoomin"
                  onClick={() => setScale(scale + 0.1)}
                  size="md"
                  bg="black"
                  aria-label="Zoom-In"
                  icon={<ZoomIn />}
                  _hover={{ bg: "var(--primary-main)" }}
                />
              </Tooltip>
            </HStack>
          </ButtonGroup>

          <Box flex="1" display="flex" justifyContent="center" alignItems="center">
            {props.pdfStatus?.loading && (
              <HStack spacing={2}>
                <Spinner size="xs" color="white" />
                <Text color="white" fontSize="xs">Loading PDF...</Text>
              </HStack>
            )}
            {props.pdfStatus?.error && (
              <Text color="red.300" fontSize="xs" fontWeight="bold">
                {props.pdfStatus.error}
              </Text>
            )}
          </Box>

          {props.pdfFull ? (
            <Tooltip label="Minimize PDF">
              <IconButton
                onClick={() => {
                  props.toggleEditor();
                }}
                size="lg"
                bg="var(--secondary-main)"
                aria-label="Resize pdf"
                icon={<Resize2 />}
                _hover={{ bg: "var(--primary-main)" }}
              ></IconButton>
            </Tooltip>
          ) : (
            <Tooltip label="Maximize PDF">
              <IconButton
                onClick={() => {
                  props.toggleEditor();
                  // setClientWidth(1);
                }}
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Resize pdf"
                icon={<Resize1 />}
                bg="var(--secondary-main)"
                _hover={{ bg: "var(--primary-main)" }}
              ></IconButton>
            </Tooltip>
          )}

        </HStack>
      </div >

      <div
        className={twoPageView ? styles.twopageview : styles.document_viewer}
        ref={props.pdfContainer}
        onMouseEnter={() => { isMouseInsideRef.current = true; }}
        onMouseLeave={() => { isMouseInsideRef.current = false; }}
        onScroll={(e) => {
          if (props.onScroll) {
            props.onScroll(e.target.scrollTop);
          }
        }}
      >
        <Document
          file={props.data}
          onLoadSuccess={onLoadSuccess}
          onLoadError={onLoadError}
          className={""} // Restyled by wrapper above
        >
          {Array.apply(null, Array(numPages))
            .map((x, i) => i + 1)
            .map((page, i) => (
              <div key={i} className={styles.pagedom} ref={pageref}>
                <Page
                  className={styles.viewer}
                  onMouseUp={selectText}
                  pageNumber={page}
                  scale={0.9 + scale}
                  // onRenderTextLayerSuccess={
                  //   scrollIntoView
                  // }
                  customTextRenderer={textRenderer}
                  data-page={page}
                // onLoadSuccess={onPageLoadSuccess}
                // onPageChange={({ pageNumber }) => onPageChange(pageNumber)}
                />
              </div>
            ))}
        </Document>
      </div>
    </div >
  );
};

const mapStateToProps = (state) => ({
  pdfsearch: state.pdfsearch.pdfSearch,
  editorJump: state.editorjump.editorJump,
});

const mapDispatchToProps = (dispatch) => {
  return {
    latexSearch: (data) => dispatch({ type: "latexSearch", payload: data }),
    pdfSearch: (data) => dispatch({ type: "pdfSearch", payload: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PdfViewer);